__turbopack_context__.v({
  "className": "L0H0mW_className",
  "variable": "L0H0mW_variable",
});
